import React from 'react'

import { SxProps } from '@mui/material'

import { useQuery } from 'utils/hooks'

import Box from 'components_new/atoms/Box'
import Button from 'components_new/atoms/Button'
import Emoji from 'components_new/atoms/Emoji'

import EmptyPlaceholder from 'components_new/molecules/EmptyPlaceholder'

interface Props {
  sx?: SxProps
}

const Empty = (props: Props) => {
  const { sx } = props

  const { query, setQuery } = useQuery()

  const handleReset = () => {
    setQuery({ search: null })
  }

  return (
    <Box sx={sx}>
      <EmptyPlaceholder
        actions={<Button onClick={handleReset}>Rensa sökning</Button>}
        background={true}
        height={512}
        size="medium"
        title={
          <>
            Hittade inga entiteter som matchade &quot;{query['search']}&quot;.{' '}
            <Emoji name={'mag'} />
          </>
        }
      />
    </Box>
  )
}

export default Empty
